import { useCallback, useRef } from 'react';

type TimerCallback = (elapsedTime: number) => void;

const useTimer = (
  callback: TimerCallback
): { startTimer: () => void; stopTimer: () => void } => {
  const startTimeRef = useRef<number | null>(null);

  const startTimer = useCallback(() => {
    startTimeRef.current = Date.now();
  }, []);
  const stopTimer = useCallback(() => {
    if (startTimeRef && startTimeRef.current) {
      const endTime = Date.now();
      const elapsedTime = endTime - startTimeRef.current;

      callback(elapsedTime);

      startTimeRef.current = null;
    }
  }, [callback]);

  return { startTimer, stopTimer };
};

export default useTimer;
